export class ErrorController {
    /* @ngInject */
    constructor(flowService, errorService, $stateParams, $state) {
        const errorType = $stateParams.errorType;

        if (errorType === "NO_USER_FOUND_FOR_SAML_CREDENTIAL") {
            // Avoid endless loop between authentication service and SAML IDP, by redirecting to error page
            $state.go('noUserFoundForSamlCredentials', {
                errorMessage: $stateParams.errorMessage,
                errorParams: $stateParams.errorParams
            });
        } else if (errorType === "ERROR_VALIDATING_SAML_MESSAGE") {
            // avoid another loop between authentication service and SAML IDP when SAML message cannot be parsed
            $state.go('errorValidatingSamlMessage', {
                errorMessage: $stateParams.errorMessage
            });
        } else if (errorType === "INSUFFICIENT_ASSURANCE_LEVEL") {
            $state.go('insufficientAssuranceLevel', {
                errorMessage: $stateParams.errorMessage
            });
        } else {
            errorService.setErrorType(errorType);
            flowService.nextFlow();
        }
    }

    ngInject() {}

}
